import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=245b1670"
import script from "./list-item.vue?vue&type=script&lang=js"
export * from "./list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245b1670')) {
      api.createRecord('245b1670', component.options)
    } else {
      api.reload('245b1670', component.options)
    }
    module.hot.accept("./list-item.vue?vue&type=template&id=245b1670", function () {
      api.rerender('245b1670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact-list-index/contact-list/list-item.vue"
export default component.exports